<template>
  <b-form-group class="mt-4">
    <b-form-row>
      <b-col cols="6" sm="3" lg="1">
        <label for="#tbl-perpage" class="font-weight-bold">Per page</label>
      </b-col>
      <b-col cols="6" sm="3" lg="1">
        <b-form-select
          id="tbl-perpage"
          class="rounded-0 border-primary"
          size="sm"
          :disabled="perPageDisabled"
          :value="perPage"
          @change="onChangePerPage"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </b-form-select>
      </b-col>
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="ml-md-auto mt-1 mt-lg-0"
        v-if="!loading && rowCount > 0 || true"
      >
        <slot name="right-content" />
      </b-col>
    </b-form-row>
  </b-form-group>
</template>
<script>
export default {
  name: 'DatatableControl',
  props: {
    perPage: {
      type: Number,
      default: 10,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 0,
    },
    perPageDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChangePerPage(payload) {
      this.$emit('update:perPage', Number(payload) || 10);
    },
  },
};
</script>
